/**
 * SessionStatusHint — shows "继续上次对话" or "新对话"
 */

import type { LatestSession } from '../../../features/chat/api';
import { formatTimeAgo } from './types';
import styles from '../AiConsultantPage.module.css';

interface SessionStatusHintProps {
  initState: 'loading' | 'resumed' | 'new';
  latestSession: LatestSession | null;
}

export function SessionStatusHint({ initState, latestSession }: SessionStatusHintProps) {
  if (initState === 'loading') return null;

  return (
    <div className={styles.sessionHint}>
      {initState === 'resumed'
        ? latestSession
          ? `继续上次对话 · ${formatTimeAgo(latestSession.lastMessageAt)}`
          : '继续上次对话'
        : '新对话'}
    </div>
  );
}
